import React from 'react';
import { Facebook, Instagram } from 'lucide-react';
import { footer } from '../mockData';
import Logo from './Logo';

const Footer = () => {
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-black border-t border-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10 mb-7">
          {/* Company Info */}
          <div className="lg:border-r lg:border-gray-800 lg:pr-10 lg:self-stretch">
            <div className="mb-4 -ml-2">
              <a href="/gradnja" aria-label="Nova-Stron građevinska tvrtka" data-testid="footer-logo-link">
                <img 
                  src="/gradnja/ns-logo.png"
                  alt="Nova-Stron Logo"
                  className="h-[106px] md:h-[123px] w-auto"
                />
              </a>
            </div>
            <p className="text-gray-400 leading-relaxed mb-4 max-w-md">
              {footer.description}
            </p>
            {/* Social Links */}
            <div className="flex space-x-4 mt-4">
              <a
                href="https://www.facebook.com/profile.php?id=61592805285777"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                data-testid="footer-facebook-link"
                className="w-10 h-10 bg-gray-900 hover:bg-[#cab28e] rounded-lg flex items-center justify-center transition-colors duration-300"
              >
                <Facebook className="w-5 h-5 text-white" />
              </a>
              <a
                href="https://www.instagram.com/nova_stron?igsh=dXp6MWVuNXJjMzZs"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                data-testid="footer-instagram-link"
                className="w-10 h-10 bg-gray-900 hover:bg-[#cab28e] rounded-lg flex items-center justify-center transition-colors duration-300"
              >
                <Instagram className="w-5 h-5 text-white" />
              </a>
              <a
                href="https://wa.me/385915256937"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp"
                data-testid="footer-whatsapp-link"
                className="w-10 h-10 bg-gray-900 hover:bg-[#cab28e] rounded-lg flex items-center justify-center transition-colors duration-300"
              >
                <svg viewBox="0 0 24 24" className="w-5 h-5 text-white" fill="currentColor" aria-hidden="true">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.71.306 1.263.489 1.694.625.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="lg:justify-self-center md:text-center">
            <h3 className="text-white font-bold text-lg mb-4 tracking-wide">
              BRZE POVEZNICE
            </h3>
            <ul className="space-y-3">
              {footer.quickLinks.map((link, index) => (
                <li key={index}>
                  <button
                    onClick={() => scrollToSection(link.href)}
                    className="text-gray-400 hover:text-[#cab28e] transition-colors duration-200"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div className="lg:justify-self-center flex items-end justify-between gap-4 md:block md:text-center">
            <div>
              <h3 className="text-white font-bold text-lg mb-4 tracking-wide">
                USLUGE
              </h3>
              <ul className="space-y-3">
                {footer.services.map((service, index) => (
                  <li key={index}>
                    <span className="text-gray-400">{service}</span>
                  </li>
                ))}
              </ul>
            </div>
            <a href="/" aria-label="Nova Stron Grup — početna" className="shrink-0 md:hidden" data-testid="footer-grup-logo-link-mobile">
              <img
                src="/grup/nova-stron-grup-footer.svg"
                alt="Nova Stron Grup"
                loading="lazy"
                className="w-[100px] min-[380px]:w-[135px] h-auto opacity-90"
                data-testid="footer-grup-logo-mobile"
              />
            </a>
          </div>

          {/* Contact Info removed — data already in STUPITE U KONTAKT section */}

          {/* Grup logo — right column with vertical divider (desktop/tablet) */}
          <div className="hidden md:flex justify-center items-center lg:self-stretch lg:border-l lg:border-gray-800 lg:pl-10 lg:pr-10">
            <a href="/" aria-label="Nova Stron Grup — početna" data-testid="footer-grup-logo-link">
              <img
                src="/grup/nova-stron-grup-footer.svg"
                alt="Nova Stron Grup"
                loading="lazy"
                className="w-[180px] h-auto opacity-90 hover:opacity-100 transition-opacity duration-300"
                data-testid="footer-grup-logo"
              />
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-6 border-t border-gray-900">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-5 md:space-y-0 text-center md:text-left">
            <p
              data-testid="footer-tagline"
              style={{ fontFamily: "'Caveat', cursive" }}
              className="text-2xl md:text-[27px] leading-none text-white"
            >
              <span className="relative inline-block text-[#cab28e]">
                Mi gradimo.
                <span className="absolute left-0 -bottom-1 w-full h-[2px] bg-[#cab28e]/80 rounded-full" />
              </span>{' '}
              Vi živite.
            </p>
            <p className="text-gray-500 text-sm">{footer.copyright}</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
